module.exports = __webpack_public_path__ + "img/tme-55x60.10be92f6.jpg";